import { Box, Heading, Button, Icon, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ArrowBackIcon } from "@chakra-ui/icons"; // Adjust icon import based on your actual icons

const NotFound = () => {
   const navigate = useNavigate();

   return (
      <Box
         height="50vh"
         display="flex"
         flexDirection="column"
         alignItems="center"
         justifyContent="center"
         bg="white"
         paddingX="1rem" // Adds some horizontal padding for better responsiveness
      >
         <Heading
            fontSize={{ base: "24px", md: "40px", lg: "56px" }}
            textAlign="center"
            color="gray.800" // Using a darker color for better contrast on white background
            mb="20px" // Slightly reduced margin for a tighter layout
         >
            Oops! Page Not Found
         </Heading>
         <Text
            fontSize={{ base: "16px", md: "20px" }}
            textAlign="center"
            mb="40px" // Giving more space before the button
            color="gray.600" // Soft color for the text
         >
            We can't seem to find the page you're looking for.
         </Text>
         <Button
            leftIcon={<Icon as={ArrowBackIcon} boxSize="20px" />} // Ensure the icon is properly sized
            colorScheme="blue"
            variant="solid"
            onClick={() => navigate("/")}
            _hover={{
               bg: "blue.700", // Ensuring the hover effect is noticeable
               color: "white", // Text color changes on hover for better visibility
            }}
            size="lg" // Larger button for easier interaction
         >
            Go to Home
         </Button>
      </Box>
   );
};

export default NotFound;
